import bg_mobi from "../../../assets/images/Home-Page-Number/bg_mobi.webp";
import bg from "../../../assets/images/Home-Page-Number/bg.webp";
import Line152 from "../../../assets/images/Home-Page-Number/Line152.svg";
export default function HomePageNumber() {
  return (
    <div
      className="w-full bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `url(${window.innerWidth < 768 ? bg_mobi : bg})`,
      }}
    >
      <div className="mx-auto w-full container py-[50px] px-[20px] flex flex-col gap-5 md:gap-6">
        <div className="w-full text-center text-white text-[32px] font-semibold ">
          <p>NHỮNG CON SỐ ĐÁNG TỰ HÀO</p>
        </div>
        <div className="w-full px-[20px] grid grid-cols-1 md:grid-cols-5 md:gap-10 gap-9 items-center justify-center  text-white">
          <div className="w-full text-center">
            <p className="text-[28px] font-semibold">98%</p>
            <p className="text-[16px] font-normal ">
              Tỷ lệ hài lòng của khách hàng
            </p>
          </div>
          <div className="hidden md:block w-full relative -right-24">
            <img src={Line152} alt="li" />
          </div>
          <div className="w-full text-center">
            <p className="text-[28px] font-semibold">Tăng 1,5 lần</p>
            <p className="text-[16px] font-normal ">
              Tốc độ quản trị công việc
            </p>
          </div>
          <div className="hidden md:block w-full relative -right-20">
            <img src={Line152} alt="lo" />
          </div>

          <div className="w-full text-center">
            <p className="text-[28px] font-semibold">Giảm 40%</p>
            <p className="text-[16px] font-normal">
              Chi phí vận hành trung tâm
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
